/**
 *
 * AdministratorBCDxGrid
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedDataTable from 'containers/AdvancedDataTable';
import {ADMINISTRATOR_BC_ANNOUNCEMENT_DX_GRID} from "./constants";
import {settings} from "containers/AdvancedDataTable/dxGridTypes";
import {columnSize, columnType, rulesColumnSizes} from 'domain/typeConstants/table';

export class AdministratorBCDxGrid extends React.PureComponent {

    getFilters() {
        return [];
    }

    getColumns() {
        return [
            {
                path: 'creationDate',
                name: 'creationDate',
                title: 'Дата',
                type: columnType.DATE,
                width: rulesColumnSizes.actualCreationDate,
            },
            {
                path: 'name',
                name: 'name',
                title: 'Наименование',
                width: rulesColumnSizes.NAME,
            },
            {
                path: 'content',
                name: 'content',
                title: 'Содержание',
                type: columnType.FORMAT_TEXT,
                width: rulesColumnSizes.content
            },
            {
                path: ['file', 'name'],
                name: 'file',
                getCellValue: (row) => row.file ? row.file.id : undefined,
                title: 'Файл',
                type: columnType.FILE,
                width: columnSize.FILE,
            },
        ];
    }

    getSorting() {
        return [{columnId: 'creationDate', columnName: 'creationDate', direction: 'asc'}];
    }

    getColumnOrder() {
        return ['creationDate', 'name', 'content', 'file'];
    }

    getActionButtons() {
        return [];
    }

    getActionMenuItems() {
        return [];
    }

    getPageSize() {
        return 10;
    }

    getTableFeatures() {
        return [
            {name: settings.SETTING_BUTTON, value: true},
            {name: settings.UPDATE_BUTTON, value: true},
        ];
    }

    render() {
        const {onActionExecuting, onRowDoubleClick, viewName} = this.props;
        return (
            <AdvancedDataTable
                name={ADMINISTRATOR_BC_ANNOUNCEMENT_DX_GRID}
                entityName={'announcements'}
                actionButtons={this.getActionButtons()}
                actionMenuItems={this.getActionMenuItems()}
                columnOrder={this.getColumnOrder()}
                columns={this.getColumns()}
                filters={this.getFilters()}
                pageSize={this.getPageSize()}
                onActionExecuting={onActionExecuting}
                onRowDoubleClick={onRowDoubleClick}
                sorting={this.getSorting()}
                tableFeatures={this.getTableFeatures()}
                viewName={viewName}
                tableType={settings.PAGING_TABLE}
                mode="parent"
            />
        );
    }
}

AdministratorBCDxGrid.propTypes = {
    viewName: PropTypes.string,
    onActionExecuting: PropTypes.func,
    onRowDoubleClick: PropTypes.func,
};

export default AdministratorBCDxGrid;
